import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import Dexie from 'dexie'
import moment from 'moment'
import SnackbarService from '@/services/snackbar-service'
const ss = new SnackbarService()

Vue.use(VueLodash, { name: 'custom', lodash: lodash })

Vue.config.productionTip = false

axios.defaults.baseURL = '/api/'

axios.interceptors.request.use(
  function(config) {
    if (store.state.token) {
      config.headers.Authorization = `Bearer ${store.state.token}`
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

const UNSAFE_METHODS = ['post', 'patch', 'delete']

axios.interceptors.request.use(
  req => {
    if (store.state.user && store.state.user.id === 1) {
      if (UNSAFE_METHODS.includes(req.method)) {
        console.log('req in interceptor', req)
        ss.notify({
          text: 'Sorry, you can not change data in the live demo',
          type: 'info',
          timeout: 6000,
        })
        store.state.loading = false
        //return new Promise(() => {})
        return req
      } else {
        return req
      }
    } else {
      if (
        store.state.account &&
        moment.utc(store.state.account.valid_until) < moment.utc()
      ) {
        console.log('Account not valid')
        ss.notify({
          text: 'Your account is not valid anymore. A new payment is required',
          type: 'warning',
          timeout: 6000,
        })
        store.state.loading = false
        return new Promise(() => {})
      }
      return req
    }
  },
  function(error) {
    return Promise.reject(error)
  }
)

Vue.filter('capitalize', function(value) {
  if (!value) return ''
  value = value.toString().replace('-', ' ')
  return value.charAt(0).toUpperCase() + value.slice(1)
})

const db: any = new Dexie('ganaderia')
db.version(4).stores({
  cows:
    '++id, birthDate, color, number, farm, fertility, iron, mother_id, mother_number, observation, pregnancyDate, race, selected, female, status, abortions, revisions',
  milks: '++id, cows, day, liter, price, priceLiter',
  syncs: '++id, action, number, farm, timestamp, message, method, url, payload, offlineAddedId',
})

db.open()

Vue.use({
  install(Vue) {
    Vue.prototype.$db = db
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
